import { AxiosError } from 'axios';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorInfo } from '../../../../../../api/model';
import { usePostSectionPreview } from '../../../../../../api/sections/sections';
import { useDefaultOptions } from '../../../../../../hooks/api';
import ConfirmModal from '../../../../../modules/ConfirmModal';
import ErrorModal from '../../../../../modules/ErrorModal';
import SpinnerModal from '../../../../../modules/SpinnerModal';

type TreeProps = {
  chapterId: number | undefined;
  sectionId: number | undefined;
  isShowPreviewWebOm: boolean; // navi, 翻訳navi 以外でWebOmプレビューを表示
};
function SectionTreeMenuPdfPreview({ chapterId, sectionId, isShowPreviewWebOm }: TreeProps) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const options = useDefaultOptions(language);

  // #region プレビュー

  // プレビューAPI
  const { data, mutateAsync, isSuccess, isLoading, isError, error } = usePostSectionPreview<
    AxiosError<ErrorInfo>,
    unknown
  >(options);
  // プレビュー確認
  const [displayConfirmPreview, setDisplayConfirmPreview] = useState(false);
  // プレビューエラー
  const [displayPreviewError, setDisplayPreviewError] = useState(false);
  // プレビュー実行
  const handlePreview = async (newValue: { value: number } | null) => {
    if (newValue != null) {
      await mutateAsync({ data: { document_type: newValue.value, chapter_id: chapterId, section_id: sectionId } });
    }
  };
  // 成功すると画面を表示
  useEffect(() => {
    if (isSuccess) {
      window.open(data.data.url);
    }
  }, [isSuccess, data?.data.url]);
  // 失敗
  useEffect(() => {
    setDisplayPreviewError(isError);
  }, [isError]);
  // #endregion

  // #region UI操作系
  // 選択されたプルダウン
  const [selectValue, setSelectValue] = useState<{ value: number } | null>(null);
  // #endregion

  return (
    <>
      <li>
        <ul className="gnav">
          <li>
            <i className="fa-solid fa-eye" />
            {t('プレビュー')}
            <ul>
              <li
                onClick={() => {
                  setDisplayConfirmPreview(true);
                  setSelectValue({ value: 10 });
                }}
              >
                {/* <i className="fa-solid fa-file-pdf" /> */}
                {t('PDF')}
              </li>
              <li
                onClick={() => {
                  setDisplayConfirmPreview(true);
                  setSelectValue({ value: 13 });
                }}
              >
                {/* <i className="fa-regular fa-file-pdf" /> */}
                {t('PDF(88%)')}
              </li>
              {isShowPreviewWebOm && (
                <li
                  onClick={() => {
                    setDisplayConfirmPreview(true);
                    setSelectValue({ value: 30 });
                  }}
                >
                  {/* <i className="fa-solid fa-earth-americas" /> */}
                  {t('WebOM')}
                </li>
              )}
            </ul>
          </li>
        </ul>
      </li>
      {/* スピナーモーダル */}
      {isLoading && <SpinnerModal />}
      {/* プレビュー確認エラー */}
      {displayPreviewError && <ErrorModal error={error} onClickOk={() => setDisplayPreviewError(false)} />}
      {/* プレビュー確認 */}
      {displayConfirmPreview && (
        <ConfirmModal
          onClickCancel={() => setDisplayConfirmPreview(false)}
          onClickOk={async () => {
            setDisplayConfirmPreview(false);
            await handlePreview(selectValue);
          }}
        >
          {t('プレビューしますか？')}
        </ConfirmModal>
      )}
    </>
  );
}
export { SectionTreeMenuPdfPreview };
